<template>
    <Row :gutter="20">
        <!-- 选中电梯信息及要修改的项目 -->
        <Col span="12">
            <Card>
                <p slot="title">
                    <Icon type="ios-film-outline"></Icon>
                    {{$t('l.selected_lifts')}}
                </p>
                <a href="#" slot="extra" @click.prevent="clearList">
                    <Icon type="ios-loop-strong"></Icon>
                    {{$t('l.clear')}}
                </a>
                <ul class="selected-list">
                    <li v-for="(item,i) in table.selectedList" :key="i">
                        <span>{{item.name}}【{{item.terminal_id}}】</span>
                    </li>
                </ul>
            </Card>
            <!-- 展示选中的项目 -->
            <p class="explain margin-top-5 margin-bottom-5">${{$t("l.warn_note")}}：{{$t("l.explain14")}}</p>
            <!-- 选择要修改的项目 -->
            <Card>
                <p slot="title">
                    
                    <Icon type="ios-film-outline"></Icon>
                     {{!warnModal.changeWarnConfig?$t('l.lift_info'):$t('l.parts_warn_config')}}
                </p>
                <a v-if="$ifauth('btn_parts_warn_config')" href="#"  slot="extra" @click.prevent="warnModal.changeWarnConfig=!warnModal.changeWarnConfig">
                    <Icon type="ios-loop-strong"></Icon>
                    {{!warnModal.changeWarnConfig?$t('l.change_war_config'):$t('l.change_deviceInfo_config')}}
                </a>
                <a href="#" style="color:#33ccff;" slot="extra" @click.prevent="onSubmit">
                    <Icon type="ios-loop-strong"></Icon>
                    {{$t('l.submit')}}
                </a>
                <!-- 电梯基本信息 -->
                <template v-if="!warnModal.changeWarnConfig">
                    <Form class="selected-form" ref="modal">
                        <FormItem :label="$t('l.lift_type')">
                            <Select :placeholder="$t('l.remark78')" v-model="device.device_param.type">
                                <Option v-for="item in  deviceTypeList"
                                        :value="item.id"
                                        :key="item.id">{{ item.lable }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="rated_speed" :label="$t('l.rated_speed')">
                            <Input v-model="device.device_param.rated_speed" :placeholder="$t('l.rated_speed')"/>
                        </FormItem>
                        <FormItem prop="rated_load" :label="$t('l.rated_load')">
                            <Input v-model="device.device_param.rated_load" :placeholder="$t('l.rated_load')"/>
                        </FormItem>
                        <!--<FormItem prop="factory_cid" :label="$t('l.manufacturer')">-->
                            <!--<Select :placeholder="$t('l.remark72')"-->
                                    <!--v-model=" device.factory_cid"-->
                                    <!--filterable-->
                                    <!--remote-->
                                    <!--:remote-method="remoteSearchFactory"-->
                                    <!--@on-change="remoteSearchFactoryBranch('', 'replace')">-->
                                <!--<Option v-for="(factory) in search.factory_cid.values" :value="factory.id"-->
                                        <!--:key="factory.id">{{factory.name}}</Option>-->
                            <!--</Select>-->
                        <!--</FormItem>-->
                        <FormItem prop="factory_branch" :label="$t('l.manufacturer_branch')" v-if=" device.factory_cid>0">
                            <Select :placeholder="$t('l.remark82')"
                                    v-model=" device.factory_branch"
                                    filterable
                                    remote
                                    :remote-method="remoteSearchFactoryBranch">
                                <Option v-for="(factory) in search.factory_branch.values" :value="factory.id"
                                        :key="factory.id">{{factory.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="mt_cid" :label="$t('l.mt_company')">
                            <Select :placeholder="$t('l.remark83')"
                                    v-model=" device.mt_cid"
                                    filterable
                                    remote
                                    :remote-method="remoteSearchMT"
                                    @on-change.stop="remoteSearchMTWorker">
                                <Option v-for="(depart) in search.mt_cid.values" :ref="'option'+depart.id"
                                        :value="depart.id" :key="depart.id">{{depart.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  :label="$t('l.mt_person')">
                            <Row :gutter="5">
                                <Col span="22">
                                    <Select :placeholder="$t('l.remark84')"
                                            v-model="mt_worker_mbile"
                                            multiple
                                            filterable>
                                        <Option v-for="(member) in search.j_mt_woker.values" :value="member.mobile"
                                                :key="member.mobile">{{member.name}}({{member.mobile}})</Option>
                                    </Select>
                                </Col>
                                <Col span="2">
                                    <Button :title="$t('l.add_maintenance')" @click="addMtWorkers">+</Button>
                                </Col>
                            </Row>
                        </FormItem>
                        <FormItem :label="$t('l.principal')">
                            <Row :gutter="5">
                                <Col span="22">
                                    <Select :placeholder="$t('l.remark85')"
                                            v-model="fzrs_mobile"
                                            multiple
                                            filterable>
                                        <Option v-for="(member) in search.j_fzrs.values" :value="member.mobile"
                                                :key="member.mobile">{{member.name}}({{member.mobile}})</Option>
                                    </Select>
                                </Col>
                                <Col span="2">
                                    <Button :title="$t('l.add_principal')" @click="addFzrs">+</Button>
                                </Col>
                            </Row>
                        </FormItem>
                        <FormItem :label="$t('l.ad_company')">
                            <Select :placeholder="$t('l.remark86')"
                                    v-model="device.ad_cid"
                                    filterable
                                    remote
                                    :remote-method="remoteSearchAD" >
                                <Option v-for="(depart) in search.ad_cid.values" :value="depart.id" :key="depart.id">{{depart.name}} </Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="alarm_charger_mobile" :label="$t('l.alarm_mobile')">
                            <Row :gutter="5">
                                <Col span="22">
                                    <Select :placeholder="$t('l.remark87')"
                                            v-model="alarm_charger_mobile"
                                            multiple
                                            filterable
                                            clearable
                                            @on-clear="clear" >
                                        <Option v-for="(member) in search.j_alarm_charger.values" :value="member.mobile"
                                                :key="member.mobile">{{member.name}}({{member.mobile}})</Option>
                                    </Select>
                                </Col>
                                <Col span="2">
                                    <Button :title="$t('l.add_alarm_mobile')" @click="addAlarmCharger">+</Button>
                                </Col>
                            </Row>
                        </FormItem>
                        <!-- 管理员分配谁能给电梯设置过期时间 -->
                        <template v-if="$store.state.user.user.show_lift_endtime||$store.state.user.isROOT">
                            <FormItem :label="$t('l.lift_monitor_end_time')">
                                <DatePicker type="date" v-model="device.end_time" :placeholder="$t('l.remark200')"></DatePicker>
                            </FormItem>
                        </template>
                        <FormItem :label="$t('l.add_capacity')">
                            <template>
                                <Checkbox :value="checkAll" :indeterminate="indeterminate"
                                          @click.prevent.native="handleCheckAll"><span class="text-font-size">{{$t('l.select_all')}}</span>
                                </Checkbox>
                            </template>
                            <template>
                                <CheckboxGroup v-model="device.j_extra_capacity" @on-change="checkAllGroupChange">
                                    <Checkbox v-for="(item,i) in  extra_capacity_list" :key="i" border
                                              :label="item.index">
                                        <span class="text-font-size">{{$t(item.value)}}</span>
                                    </Checkbox>
                                </CheckboxGroup>
                            </template>
                        </FormItem>
                    </Form>
                </template>
               <template v-else>
                   <Row>
                       <ul class="full-x parts-label-ul">
                           <template v-if="warnModal.list.length">
                               <li class="parts-label parts-label-title">
                                   <span style="width: 10%;"  class="parts-label-id">ID</span>
                                   <span style="width: 20%;">{{$t('l.parts_name')}}</span>
                                   <span style="width: 20%;">{{$t('l.life_limit')}} (/h)</span>
                               </li>
                               <li class="full-x parts-label" v-for="(elem,i) in warnModal.list" >
                                   <span style="width: 10%;" class="parts-label-id">{{elem.id}}.</span>
                                   <span style="width: 20%;">{{elem.name}}</span>
                                   <Input class="margin-left-5" style="width: 20%;" v-model="elem.limit_life" />
                               </li>
                           </template>
                           <template v-else>
                               <div class="to-setting-box">{{$t('l.remark211')}}<span class="to-setting" @click="()=>{$router.push('/system/settings'),warnModal.show = false}">“{{$t('l.system_setting')}}->{{$t('l.parts_warn_config')}}”</span>{{$t('l.remark212')}}。</div>
                           </template>
                       </ul>
                   </Row>
               </template>
            </Card>
        </Col>
        <!-- 电梯表信息 -->
        <Col span="12">
            <!-- 当前电梯信息列表 -->
            <Table max-height="495" :columns="getColumns" :data="table.data" :loading="table.loading" @on-selection-change="(v)=>{table.selectedList=v}"></Table>
            <Row>
                <Page size="small"
                      :current="table.page.current"
                      :page-size="table.page.size"
                      :total="table.page.total"
                      :page-size-opts="table.page.sizeOptions"
                      show-elevator show-sizer show-total
                      @on-page-size-change="($event)=>{table.page.size=$event;loadData(1)}"
                      @on-change="loadData($event)">
                </Page>
            </Row>
        </Col>
    </Row>
</template>

<script>
    import util from '@/libs/util';
    export default {
        name: "batch-update-device",
        props:{
            deviceTypeList:Array,
            search:Object,
            extra_capacity_list:Array,
            batchModalShow:Boolean,

            chargerMap:Object ,
            fzrMap:Object,
            mtWorkersMap:Object
        },
        components:{

        },
        data(){
            return{
                table:{
                    columns:[],
                    data:[],
                    loading:false,
                    selectedList:[],
                    page: {
                        current: 1,  // 当前页码
                        size: 24, // 每页个数
                        sizeOptions: [12, 18, 24, 48, 60],
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword: ''
                    },
                },
                device: {
                    device_param: {
                        rated_speed: "",
                        rated_load: "",
                        type: 0,
                        is_through_door: 0
                    },
                    // factory_cid: 0,
                    factory_branch: 0,
                    mt_cid: 0,
                    j_mt_workers: [],
                    ad_cid: 0,
                    end_time:'',
                    j_alarm_charger: null,
                    j_extra_capacity: []
                },
                checkAll: false,
                indeterminate: true,
                alarm_charger_mobile:[], // 故障告警人
                fzrs_mobile:[], // 负责人
                mt_worker_mbile:[], // 维保负责人
                warnModal:{
                    changeWarnConfig:false,
                    list:[],

                }
            }
        },
        computed:{
            getColumns(){
              // 2025年10月28日 王欢 按照姜铎和闵总沟通后的要求将中富电梯的厂家代码显示全部替换成电梯唯一工号
              let conmpany = this.$store.state.user.user.company;
              let isZhongFuCompany = conmpany.id === 154 || conmpany.pid === 154;
                return [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        key:'name',
                        title: this.$t('l.elevator_name')
                    },
                    {
                        key:'terminal_id',
                        title: this.$t('l.terminal_id')
                    },
                    {
                        key:'code',
                        title:isZhongFuCompany?this.$t('l.device_unique_id'):this.$t('l.device_number')
                    },
                ]
            }
        },
        methods:{
            clearList(){
                this.table.selectedList=[];
                this.table.data = this.table.data.map(elem=>{
                    elem.__checked=false;
                    return elem;
                });
            },
            loadData(page){
                let params = {
                    page: page || this.table.page.current,
                    size: this.table.page.size,
                    orderKey: this.table.page.sortKey,
                    orderMethod: this.table.page.sortMethod,
                    keyword: this.table.page.keyword,
                    noStatus:true
                };
                this.table.loading = true;
                util.ajax.post('/device/list', params).then(res => {
                    this.setPage(res.data);
                    this.table.loading=false;
                })
            },
            setPage(pageInfo){
                this.table.data = pageInfo.list.map(elem=>{
                    elem.__checked=false;
                    return elem;
                });
                this.table.page.current = pageInfo.pageNumber;
                this.table.page.total = pageInfo.totalRow;
            },
            remoteSearchFactory(value) {
                this.$emit('remoteSearchFactory',value)
            },
            remoteSearchMT(){
                this.$emit('remoteSearchMT');
            },
            remoteSearchAD(){
                this.$emit('remoteSearchAD');
            },
            remoteSearchMTWorker(){
                this.$emit('remoteSearchMTWorker');
            },
            remoteSearchFactoryBranch(v1,v2){
                this.$emit('remoteSearchFactoryBranch',v1,v2);
            },
            // 添加告警人
            addAlarmCharger(){
                let charger = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_alarm_mobile')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: charger.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                charger.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label:  this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: charger.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                charger.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!charger.name || !charger.mobile) {
                            this.$Message.warning(this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(charger.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.$emit('addAlarm',charger);
                        this.alarm_charger_mobile.push(charger.mobile);
                    }
                })

            },
            // 添加负责人
            addFzrs(){
                let fzr = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_principal')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: fzr.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                fzr.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: fzr.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                fzr.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!fzr.name || !fzr.mobile) {
                            this.$Message.warning( this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(fzr.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.$emit("addFzr",fzr)
                        this.fzrs_mobile.push(fzr.mobile);
                    }
                })

            },
            // 新建维保负责人
            addMtWorkers(){
                let mt = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_maintenance')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: mt.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                mt.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: mt.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                mt.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!mt.name || !mt.mobile) {
                            this.$Message.warning(this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(mt.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.mt_worker_mbile.push(mt.mobile);
                        this.$emit("addMtWorker",mt);
                    }
                })
            },
            clear(){
                this.device.j_alarm_charger = null;
                this.alarm_charger_mobile = [];
            },
            handleCheckAll() {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.device.j_extra_capacity = this.extra_capacity_list.map(item => {
                        return item.index;
                    });
                } else {
                    this.device.j_extra_capacity = [];
                }
            },
            checkAllGroupChange(data){
                if (data.length === this.extra_capacity_list.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            // loadPartsLife(){
            //     util.ajax.get('/settings/parts_config').then(res => {
            //         this.warnModal.list = res.data.config;
            //     })
            // },
            onSubmit(){
            //    提交 保存 所有选中的device ，验证是否存在未选择的情况 发请求 同时关闭 表单
                if(this.table.selectedList.length){
                    if (!this.warnModal.changeWarnConfig) {
                        if (this.alarm_charger_mobile.length) {
                            this.device.j_alarm_charger = [];
                            this.alarm_charger_mobile.forEach(mobile => {
                                let charger = this.chargerMap[mobile];
                                this.device.j_alarm_charger.push({
                                    mobile: charger.mobile,
                                    name: charger.name
                                });
                            })
                        } else {
                            this.device.j_alarm_charger = null;
                        }
                        if (this.fzrs_mobile.length) {
                            this.device.j_fzrs = [];
                            this.fzrs_mobile.forEach(mobile => {
                                let fzr = this.fzrMap[mobile];
                                if (fzr) {
                                    this.device.j_fzrs.push({
                                        mobile: fzr.mobile,
                                        name: fzr.name
                                    });
                                }
                            })
                        }
                        else {
                            this.device.j_fzrs = null;
                        }
                        if (this.mt_worker_mbile.length) {
                            this.device.j_mt_workers = [];
                            this.mt_worker_mbile.forEach(mobile => {
                                let mt = this.mtWorkersMap[mobile];
                                if (mt) {
                                    this.device.j_mt_workers.push({
                                        mobile: mt.mobile,
                                        name: mt.name
                                    });
                                }
                            })
                        }
                        else {
                            this.device.j_mt_workers = null;
                        }
                        util.ajax.post('device/batchupdate',{
                            ids:this.table.selectedList.map(elem=>elem.id),
                            device: this.device
                        }).then(res=>{
                            if (!res.code){
                                this.$emit("save");
                                this.$Message.success(this.$t('l.edit_success'))
                            }
                        })
                    }
                    else { // 批量更新设备部件使用寿命上限
                        let map ={},list=[];
                        this.warnModal.list.forEach(elem=>{
                            map[elem.id] = elem;
                        })
                        this.table.selectedList.map(device => {
                            let newdevice = {id:device.id};
                            if (!device.parts_life) {
                                newdevice['parts_life'] = this.warnModal.list;
                            }else{
                                let parts_life = typeof device.parts_life == "string"?JSON.parse(device.parts_life):device.parts_life;
                                Object.keys(map).forEach(id => {
                                    let part = parts_life.find(elem=>elem.id==id);
                                    if (part) {
                                        part.limit_life = map[id].limit_life;
                                    } else{
                                        parts_life.push({id:id,limit_life:map[id].limit_life,use_time:0})
                                    }
                                })
                                newdevice['parts_life'] = parts_life;
                            }
                            list.push(newdevice);
                        })
                        if (list.length){
                            util.ajax.post('device/batchupdatewarnconfig',{
                                data:list
                            }).then(res=>{
                                if (!res.code){
                                    this.$emit("save");
                                    this.$Message.success(this.$t('l.edit_success'))
                                }
                            })
                        }
                    }
                }else{
                    this.$Message.warning(this.$t('l.remark92'));
                }
            }
        },
        watch:{
            batchModalShow(newValue){
                if (newValue) {
                    this.table.selectedList=[];
                    this.table.data = this.table.data.map(elem=>{
                        elem._checked=false;
                        return elem;
                    });
                    this.device = {
                        device_param: {
                            rated_speed: "",
                                rated_load: "",
                                type: 0,
                                is_through_door: 0
                        },
                        // factory_cid: 0,
                            factory_branch: 0,
                            mt_cid: 0,
                            j_mt_workers: [],
                            ad_cid: 0,
                            j_alarm_charger: null,
                            j_extra_capacity: []
                    }
                }
            }
        },
        created(){
            this.loadData();
        },
        activated(){
            // this.loadPartsLife();
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar{
        display:none;
    }
.selected-list{
    height: 120px;
    max-height: 120px;
    overflow-y: auto;
}
    .selected-form{
        height: 200px;
        max-height: 200px;
        overflow-y: auto;
    }
    /* 部件配置 */
    .parts-label-ul {
        max-height: 220px;
        overflow-y: auto;
    }

    .parts-label-ul > li {
        margin:10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .parts-label-id {
        width: 5%;
    }

    .parts-label-ul > li > span{
        display: block;
        text-align: center;
        width: 30%;
        line-height: 30px;
        font-size: 14px;
    }
    .parts-label-title{
        font-size: 16px;
        font-weight: bold;
    }

    .to-setting-box {
        font-size: 16px;
    }
    .to-setting{
        color: #57a3f3;
        cursor: pointer;
        text-decoration: underline;
    }

</style>